import React, { useEffect } from "react";
import Navigation from "../components/sections/Navigation";
import Footer from "../components/sections/Footer";

export const LegalLayout = ({ title, lastUpdated, children }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main className="bg-white min-h-screen">
      <Navigation />

      <article className="pt-32 sm:pt-36 pb-20 sm:pb-28 px-5 sm:px-8">
        <div className="max-w-[760px] mx-auto">
          <h1
            data-testid="legal-title"
            className="text-4xl sm:text-5xl lg:text-[3.25rem] lg:leading-[1.05] font-black tracking-tight text-[#1A1A2E]"
          >
            {title}
          </h1>
          {lastUpdated && (
            <p
              data-testid="legal-last-updated"
              className="mt-4 text-sm text-gray-500"
            >
              Last updated: {lastUpdated}
            </p>
          )}

          <div
            data-testid="legal-content"
            className="mt-10 text-[15.5px] leading-[1.8] text-gray-700
              [&_h2]:text-2xl [&_h2]:sm:text-3xl [&_h2]:font-bold [&_h2]:text-[#1A1A2E] [&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:tracking-tight
              [&_h3]:text-lg [&_h3]:sm:text-xl [&_h3]:font-semibold [&_h3]:text-[#1A1A2E] [&_h3]:mt-8 [&_h3]:mb-3 [&_h3]:tracking-tight
              [&_p]:my-4
              [&_ul]:my-4 [&_ul]:pl-6 [&_ul]:list-disc [&_ul]:space-y-2
              [&_ol]:my-4 [&_ol]:pl-6 [&_ol]:list-decimal [&_ol]:space-y-2
              [&_li]:leading-relaxed
              [&_a]:text-[#7B5EA7] [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-[#4B9FE8]
              [&_strong]:text-[#1A1A2E] [&_strong]:font-semibold"
          >
            {children}
          </div>
        </div>
      </article>

      <Footer />
    </main>
  );
};

export default LegalLayout;
